import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import _ from 'lodash'

export class KeyboardSelector extends Component {
  static propTypes = {
    selected: PropTypes.any,
    onSelect: PropTypes.func,
    options: PropTypes.array,
    className: PropTypes.string,
    style: PropTypes.any,
  }

  static defaultProps = {
    onSelect: _.noop,
    className: '',
  }

  state = {
    selected: this.getStartingIndex()
  }

  componentDidMount() {
    this._isMounted = true
    window.addEventListener('keydown', this.handleKeys.bind(this))
  }

  componentWillUnmount() {
    this._isMounted = false
    window.removeEventListener('keydown', this.handleKeys.bind(this))
  }

  getStartingIndex() {
    const index = _.findIndex(this.props.options, (option) => _.isEqual(option, this.props.selected))

    return index > -1 ? index : 0
  }

  handleKeys(e) {
    if (this._isMounted) {
      let selected = _.clone(this.state.selected)
      if (e.keyCode === 38) {
        e.preventDefault()
        selected = selected === 0 ? this.props.options.length - 1 : selected - 1
        this.setState({ selected })
      } else if (e.keyCode === 40) {
        e.preventDefault()
        selected = selected === this.props.options.length - 1 ? 0 : selected + 1
        this.setState({ selected })
      } else if (e.keyCode === 13) {
        e.preventDefault()
        this.props.onSelect(this.props.options[selected].value, selected)
      }
    }
  }

  render() {
    return (
      <ul className={cx('keyboard-selector', this.props.className)} style={this.props.style}>
        {_.map(this.props.options, (option, idx) => this.renderOption(option, idx))}
      </ul>
    )
  }

  renderOption(option, idx) {
    return (
      <li
        key={idx}
        className={cx({ 'active': idx === this.state.selected})}
        onClick={() => {
          this.setState({ selected: idx })
          this.props.onSelect(option.value, idx)
        }}
      >
        {option.content}
      </li>
    )
  }
}
